import { api } from '../client';

/**
 * Comandos enviados ao Traccar via `POST /api/commands/send`.
 *
 * Formato payload (custom command, p/ rastreadores GT06 e similares):
 *   {
 *     "deviceId": 43768,
 *     "type": "custom",
 *     "attributes": { "data": "RELAY,1#" },
 *     "textChannel": false
 *   }
 *
 * `type: 'custom'` envia o conteúdo de `attributes.data` como string crua pelo
 * canal IP (TCP) que o Traccar mantém aberto com o equipamento. Para enviar
 * via SMS, use `textChannel: true`.
 *
 * Esta é a ÚNICA rota de escrita liberada no guard read-only do client.
 */
export const commandsApi = {
  /** Envia um comando GT06 (texto cru) ao equipamento via canal IP. */
  send: (deviceId: number, data: string) =>
    api.post<unknown>('/commands/send', {
      body: {
        deviceId,
        type: 'custom',
        attributes: { data },
        textChannel: false,
      },
    }),
};

/** Comandos GT06 padrão usados na frota Fismatek (canal online/TCP). */
export const GT06_COMMANDS = {
  block: 'RELAY,1#',
  unblock: 'RELAY,0#',
  position: 'POSITION#',
  reset: 'RESET#',
} as const;

/** Versão SMS de um comando: texto padrão + alternativo (fallback). */
export interface SmsCommandSpec {
  /** comando SMS padrão (mesmo texto do TCP). */
  primary: string;
  /**
   * comando SMS alternativo, usado quando o padrão é ENTREGUE mas não muda o
   * status da máquina (alguns rastreadores não agem no RELAY,X# via SMS).
   */
  alt?: string;
}

/**
 * Versão SMS de cada comando (enviada ao CHIP via CHIPMAX). Só os comandos que
 * têm versão SMS configurada aparecem aqui; os demais não podem ir por SMS.
 * Padrão = mesmo texto do TCP (RELAY,1#/RELAY,0#); alternativo (DY/KY) entra
 * quando o padrão é entregue mas não surte efeito.
 */
export const GT06_SMS_COMMANDS: Partial<Record<keyof typeof GT06_COMMANDS, SmsCommandSpec>> = {
  block: { primary: 'RELAY,1#', alt: 'DY' },
  unblock: { primary: 'RELAY,0#', alt: 'KY' },
};
